import { faQrcode } from '@fortawesome/free-solid-svg-icons';

import { ReactComponent as Checkmark } from "../picture/checkmark.svg";
import { ReactComponent as Cross } from "../picture/cross.svg";

const Icons = {
	'barcode': faQrcode,
	'checkmark.svg': Checkmark,
	'cross.svg': Cross 
};

export default Icons;
